// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","container":"App_container__Rt8T2"};